<p-dropdown
  [options]="categories"
  [(ngModel)]="selectedCategory"
  (ngModelChange)="valueChange()"
  [placeholder]="'storedDocuments.filteringList.placeholderLabel' | translate"
  optionLabel="name"
  class="flex-1"
  styleClass="w-full">
  <ng-template
    pTemplate="item"
    let-category>
    <div class="p-dropdown-item-container flex items-center px-3 py-2 gap-2 rounded-md">
      <span class="flex-initial text-sm text-black">{{
        category.isCustom ? category.name : (getGenericCategoryTranslationUri(category.name) | translate)
      }}</span>
      <div
        *ngIf="category.documentCount"
        class="bg-primary/60 text-white font-bold text-center text-[0.5rem] h-4 min-w-4 leading-4 px-1 rounded-full">
        {{ category.documentCount }}
      </div>
    </div>
  </ng-template>
  <ng-template
    pTemplate="selectedItem"
    let-category>
    <span class="p-0">{{
      category.isCustom ? category.name : (getGenericCategoryTranslationUri(category.name) | translate)
    }}</span>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      [text]="true"
      class="text-xs text-primary hover:bg-primary/5 active:bg-primary/20 px-4 py-2 m-1"
      styleClass="focus:shadow-none rounded-none font-normal"
      (click)="editList()">
      <i class="pi pi-pencil text-xs mr-2"></i>
      <span>{{ "storedDocuments.filteringList.customListButton" | translate }}</span>
    </button>
  </ng-template>
</p-dropdown>
